// extracted by mini-css-extract-plugin
export default {"percentInputGroup":"ElementTypeScreen_percentInputGroup__cpte9","percentSuffix":"ElementTypeScreen_percentSuffix__iPnY0"};